import {useEffect} from 'react';
import {isAuthValid} from '@jobseeker/common-core/utils/authHelper';
import gladiatorService from '@jobseeker/common-core/services/gladiator.service';
import {openUrl} from '@jobseeker/common-core/utils/common';

import type {AnyAction, Dispatch} from '@reduxjs/toolkit';

const useValidateAuth = (dispatch: Dispatch<AnyAction>, isAuthOnly = false) => {
  useEffect(() => {
    const validateAuth = async () => {
      if (!isAuthValid()) {
        dispatch({type: 'Auth/set_user_logged_out'});
        dispatch({type: 'User/clear_user_profile'});
        dispatch({type: 'User/clear_profile_completeness'});
        if (isAuthOnly) {
          openUrl('/', '_self');
        }
      } else {
        try {
          const authInfo = await gladiatorService.validate('validate');
          dispatch({
            type: 'Auth/set_user_loggedin',
          });

          dispatch({
            type: 'Auth/set_auth',
            payload: {
              token: authInfo?.token,
            },
          });

          dispatch({
            type: 'Auth/set_user_info',
            payload: {
              userId: authInfo?.userId,
            },
          });
          sessionStorage.setItem('userId', authInfo?.userId || '-1');
          sessionStorage.setItem(
            'status',
            authInfo?.userId ? 'LoggedIn' : 'LoggedOut'
          );
        } catch (err) {
          dispatch({type: 'Auth/set_user_logged_out'});
          dispatch({type: 'User/clear_user_profile'});
          dispatch({type: 'User/clear_profile_completeness'});
          if (isAuthOnly) {
            openUrl('/', '_self');
          }
        }
      }

      dispatch({
        type: 'AppContext/set_layout_validated',
        payload: true,
      });
    };

    validateAuth();
  }, [isAuthOnly]);
};

export default useValidateAuth;
